import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block text-sm font-medium leading-6 text-gray-900"
}
const _hoisted_2 = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
}
const _hoisted_3 = {
  key: 0,
  class: "text-xs mt-1 text-red-600 sm:col-span-2 sm:items-end sm:col-start-2"
}

import { ExclamationCircleIcon } from "@heroicons/vue/24/solid";
import { useField, useFieldError } from "vee-validate";
import { PropType } from "vue";
import OaiCombobox from "shared/components/other/OaiCombobox.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchListField',
  props: {
  name: {
    type: String as PropType<string>,
    required: true,
  },
  inlineField: {
    type: Boolean as PropType<boolean>,
    required: false,
  },
  options: {
    type: Array as PropType<{ value: string; name: string }[]>,
    required: true,
  },
  label: {
    type: String,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  minWidth: {
    type: Number,
    required: false,
    default: 180,
  },
},
  setup(__props) {

const props = __props;

const errorMessage = useFieldError(props.name);
const { value, setValue } = useField<string>(props.name);

const handleChange = (newValue: string) => {
  setValue(newValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'sm:grid sm:grid-cols-3 sm:gap-x-4 sm:items-center': __props.inlineField })
    }, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(__props.label), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass([
          'relative mt-2 sm:mt-0 rounded-md shadow-sm',
          { 'sm:col-span-2 max-w-lg sm:max-w-xs': __props.inlineField },
        ])
      }, [
        _createVNode(OaiCombobox, {
          options: __props.options,
          "onUpdate:selected": handleChange,
          selected: _unref(value),
          readonly: __props.readonly,
          minWidth: __props.minWidth,
          inputFieldClass: 
            [
              'relative outline-none block w-full text-left rounded-md border-0 py-1.5 pl-3 ring-1 ring-inset focus:ring-2 focus:ring-inset text-sm sm:leading-6',
              _unref(errorMessage)
                ? 'text-red-900 ring-red-300 placeholder:text-red-300 focus:ring-red-500 pr-3'
                : 'text-gray-900 ring-gray-300 placeholder:text-gray-400 focus:ring-orange-300 pr-3',
            ].join(' ')
          
        }, null, 8, ["options", "selected", "readonly", "minWidth", "inputFieldClass"]),
        (_unref(errorMessage))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(ExclamationCircleIcon), {
                class: "h-5 w-5 text-red-500",
                "aria-hidden": "true"
              })
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})